import { render, staticRenderFns } from "./PageSeven.vue?vue&type=template&id=2b94e3ad&"
import script from "./PageSeven.vue?vue&type=script&lang=js&"
export * from "./PageSeven.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports